package persistence

class TimedOutPersistence(val persistence: Persistence) {
    fun getTimedOutTimeStamp(): Long? {
        return persistence.get("timedOutTimeStamp")?.toLongOrNull()
    }

    fun setTimedOutTimeStamp(timeStamp: Long) {
        persistence.set("timedOutTimeStamp", timeStamp.toString())
    }

    fun deleteTimedOutTimeStamp() {
        persistence.delete("timedOutTimeStamp")
    }
}